'use strict';

var AppDispatcher = require('../AppDispatcher'),
    invariant = require('react/lib/invariant');

var ActionUtils = {
  /**
   * Requests a single entity.
   */
  requestEntity(options) {
    var { idAttribute, fields, store, action, callAPI, getIdForStore } = options,
        id = options[idAttribute],
        storeId = getIdForStore ? getIdForStore(id) : id;

    invariant(idAttribute, 'You forgot to pass idAttribute');
    invariant(id, 'You forgot to pass ' + idAttribute);
    invariant(action, 'You forgot to pass the action.');

    if (store.contains(storeId, fields)) {
      return;
    }

    var payload = {
      type: action
    };

    payload[idAttribute] = id;
    AppDispatcher.handleViewAction(payload);

    callAPI(id);
  },

  /**
   * Removes an entity
   */
  deleteEntity(options) {
    var { idAttribute, action, callAPI } = options,
        id = options[idAttribute];

    invariant(idAttribute, 'You forgot to pass idAttribute');
    invariant(id, 'You forgot to pass ' + idAttribute);
    invariant(action, 'You forgot to pass the action.');

    var payload = {
      type: action
    };

    payload[idAttribute] = id;
    AppDispatcher.handleViewAction(payload);

    callAPI(id);
  },

  /**
   * Posts an entity
   */
  postEntity(options) {
    var { entity, action, callAPI } = options;

    invariant(action, 'You forgot to pass the action.');

    var payload = {
      type: action,
      entity: entity
    };

    AppDispatcher.handleViewAction(payload);

    callAPI(entity);
  },

  /**
   * Updates an entity
   */
  updateEntity(options) {
    var { entity, action, callAPI } = options;

    invariant(action, 'You forgot to pass the action.');

    var payload = {
      type: action,
      entity: entity
    };

    AppDispatcher.handleViewAction(payload);

    callAPI(entity);
  },

  /**
   * Requests a page for global list (such as feed).
   */
  requestPage({ isInitialRequest, store, action, callAPI }) {
    invariant(action, 'You forgot to pass the action.');

    if (store.isExpectingPage()) {
      return;
    }

    var pageCount = store.getPageCount(),
        isInvalidated = store.isInvalidated(),
        nextPageUrl;

    if (isInitialRequest && pageCount > 0 && !isInvalidated) {
      return;
    }

    if (!isInvalidated) {
      nextPageUrl = store.getNextPageUrl();
    }

    AppDispatcher.handleViewAction({
      type: action
    });

    callAPI(nextPageUrl);
  },

  /**
   * Requests a page for indexed list (such as user's published).
   */
  requestIndexedPage(options) {
    var { idAttribute, isInitialRequest, store, action, callAPI, getIdForStore } = options,
        id = options[idAttribute],
        storeId = getIdForStore ? getIdForStore(id) : id;

    invariant(action, 'You forgot to pass the action.');
    invariant(idAttribute, 'You forgot to pass idAttribute');
    invariant(id, 'You forgot to pass ' + idAttribute);

    if (store.isExpectingPage(storeId)) {
      return;
    }

    var pageCount = store.getPageCount(storeId),
        isInvalidated = store.isInvalidated(storeId),
        nextPageUrl;

    if (isInitialRequest && pageCount > 0 && !isInvalidated) {
      return;
    }

    if (!isInvalidated) {
      nextPageUrl = store.getNextPageUrl(storeId);
    }

    var payload = {
      type: action
    };

    payload[idAttribute] = id;
    AppDispatcher.handleViewAction(payload);

    callAPI(id, nextPageUrl);
  }
};

module.exports = ActionUtils;


/** WEBPACK FOOTER **
 ** ./utils/ActionUtils.js
 **/